import { useMemo } from 'react';
import { DirectoryModel } from 'shared/domain/directory/directoryModel';
import { useDocumentationStore } from '../store';

/**
 * Returns a memoized Map for O(1) directory lookup by ID.
 * Uses the already-loaded `allDirectories` from the documentation store.
 */
export function useDirectoriesLookupMap(): Map<string, DirectoryModel> {
  const allDirectories = useDocumentationStore.use.allDirectories();

  return useMemo(() => {
    const map = new Map<string, DirectoryModel>();
    for (const directory of allDirectories) {
      if (directory._id) {
        map.set(directory._id, directory);
      }
    }
    return map;
  }, [allDirectories]);
}
